import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'

Locale.getInstance().registerKeySet('fr', 'lvc-free-show-block', {
  freeShowCheckbox: 'Représentation gratuite',
  freeExhibitionCheckbox: 'Exposition gratuite',
  placeholder: 'Écrivez ici...',
  priceLabel: 'Prix*',
  choose: 'Choisir',
})

Locale.getInstance().registerKeySet('en', 'lvc-free-show-block', {
  freeShowCheckbox: 'Reservation required',
  placeholder: 'Write here...',
  priceLabel: 'Price*',
  choose: 'Choose',
})

export interface LvcFreeShowBlock {
  title: string
  placeholder: string
  open: boolean
  defaultValue: any
  value: string
}

export class LvcFreeShowBlock extends MinzeElement {
  changeCb = Callback.attach(this.onChange.bind(this))

  attrs: Attrs = [['data-type']]

  reactive: Reactive = [
    ['value', ''],
    ['showFields', false],
  ]

  static observedAttributes = ['title', 'on-change']

  errors: any = {
    price: false,
    priceType: false,
  }

  async onBlur(e: Event): Promise<void> {
    this.open = false
    this.rerender()
  }

  public async onChange(): Promise<void> {
    await this.updateCheckbox()
  }

  public async updateCheckbox(): Promise<void> {
    let freeShowElement = this.select('[name="freeShow"]')

    if (!freeShowElement) {
      return
    }
    this.freeShow = freeShowElement?.getAttribute('checked') || ''
    this.showFields = this.freeShow === 'true' || this.freeShow === true
  }

  renderCheckboxLabel = () => {
    if (this.dataType === 'exhibition') {
      return Locale.getKey('lvc-free-show-block.freeExhibitionCheckbox')
    }
    return Locale.getKey('lvc-free-show-block.freeShowCheckbox')
  }

  html = () => {
    return `

        <lvc-box display="flex" flexDirection="column" rowGap="8px">
            <lvc-box display="flex" alignItems="center" justifyContent="space-between">
                <lvc-checkbox name="freeShow" on-change="${this.changeCb}" default-value="${this.showFields}" secondary-style="true" label="${this.renderCheckboxLabel()}"></lvc-checkbox>
            </lvc-box>

            ${
              !this.showFields
                ? `<lvc-box display="flex" flexDirection="row" alignItems="flex-end"justifyContent="space-between" columnGap="16px">
                <lvc-box display="flex" flexGrow="1">
                    <lvc-input id="price" name="price" placeholder="${Locale.getKey('lvc-free-show-block.placeholder')}" label="${Locale.getKey('lvc-free-show-block.priceLabel')}" error="${this.errors.price}" secondary-style="true">
                    </lvc-input>
                </lvc-box>
                <lvc-box display="flex" flexGrow="1">
                    <lvc-price-type-field></lvc-price-type-field>
                    <lvc-error>${this.errors.priceType}</lvc-error>
                </lvc-box>
            </lvc-box>`
                : ``
            }
        </lvc-box>

        <div class="separator"></div>
    `
  }

  css = () => {
    return `
      :host {

      }

      .separator {
        height: 2px; 
        background-color: #1E007D4D;
        margin: 24px 0px ;
      }   


    `
  }

  eventListeners: EventListeners = [[this, 'blur', this.onBlur.bind(this)]]
}
